module.exports = __webpack_public_path__ + "static/media/Pacifico-Regular.9b94499c.ttf";